// extracted by mini-css-extract-plugin
export var center = "_5p-2";
export var clickableRow = "_5p-5";
export var expandedRow = "_5p-7";
export var hoverable = "_5p-4";
export var left = "_5p-1";
export var right = "_5p-3";
export var row = "_5p-0";
export var selectedRow = "_5p-6";
export var summaryRow = "_5p-8";